import {
  SimpleForm,
  Create,
  TextInput,
  ImageInput,
  ImageField,
  ReferenceInput,
  AutocompleteInput,
  required,
  regex,
} from "react-admin";
import { getSizes } from "./utils";

export const UploadMedia = props => {
  const sizes = getSizes();

  return (
    <Create
      {...props}
      title="Качване на медия файл"
      mutationOptions={{ meta: { useFormData: true } }}
    >
      <SimpleForm>
        <TextInput
          source="name"
          label="Име (без спейсове)"
          validate={[required(), regex(/^[A-Za-z0-9-_]+$/, "Името трябва да съдържа само букви, цифри и тирета!")]}
        />
        <ReferenceInput
          reference={"applications-cms"}
          source="applicationId"
          queryOptions={{ meta: { mixed_provider: true } }}
        >
          <AutocompleteInput
            label="Application"
            filterToQuery={q => ({ Name: q })}
            optionText={"name"}
            fullWidth
          />
        </ReferenceInput>
        {sizes.map(size => (
          <ImageInput
            source={size}
            label={size}
            accept="image/*"
          >
            <ImageField
              source="src"
              title="title"
            />
          </ImageInput>
        ))}
      </SimpleForm>
    </Create>
  );
};

export default UploadMedia;
